// extracted by mini-css-extract-plugin
export var pillWrapper = "_pb-0";
export var showOverflow = "_pb-1";